module.exports = __webpack_public_path__ + "static/media/circle.7853679a.png";